<template>
  <div class="login-layout">
    <header>
      <div class="logo">
        <img v-if="logoType == 'syscall'" src="@/assets/img/syscall_logo_white.png" alt="logo" height="17"/>
        <img v-if="logoType == 'ringobell'" src="@/assets/img/ringobell_logo_white.png" alt="logo" height="17"/>
      </div>
        <h1>음성통화비상벨 통합 관리 <span class="dn"> 프로그램</span></h1>
      <div class="profile">
      </div>
    </header>

    
      <router-view></router-view>
    
    <footer class="login-footer">
      <div class="footer-content">
        <div class="row1">
          <strong class="name">{{ footerInfo.name }}</strong>
          <span><strong>대표 </strong>{{ footerInfo.ceo }}</span>
          <span><strong>사업자등록번호 </strong>{{ footerInfo.businessNumber }}</span>
        </div>
        <div class="row3">
          <span><strong>전화번호 </strong>{{ footerInfo.tel }}</span>
          <span><strong>팩스 </strong>{{ footerInfo.fax }}</span>
          <strong>주소 </strong>
          <span>{{ footerInfo.address }}</span>
          <span><strong>이메일 </strong>{{ footerInfo.email }}</span>
          <span><a :href="footerInfo.privacyPolicyURL"><strong>개인정보처리방침</strong></a></span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

import R_favicon_default from '@/assets/favicon/R_favicon_default.ico';

export default {
  name: "LoginLayout",
  data() {
    return {
      dropdownVisible: false,
      logoType: '',
      footerInfo : {
        name: '',
        ceo: '',
        businessNumber: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        privacyPolicyURL: ''
      }
    };
  },
  mounted() {
    if(window.location.hostname.includes('ringo')){
      this.logoType = 'ringobell';
      document.title = "링고벨 통합 관리 프로그램";
      this.changeFavicon(R_favicon_default);
      this.footerInfo ={
        name: '(주)링고벨',
        ceo: '이정환',
        businessNumber: '224-88-00133',
        address: '(03334) 서울특별시 은평구 연서로21길 12-7 (갈현동) 링고벨',
        tel: '1833-5785',
        fax: '02-389-5885',
        email: 'ringo@ringobell.co.kr',
        privacyPolicyURL: 'https://www.ringosos.co.kr/privacy_ringobell'
      }
    }else{
      this.logoType = 'syscall';
      this.footerInfo ={
        name: '(주)엔티티웍스',
        ceo: '류영태',
        businessNumber: '110-81-92204',
        address: '(03328) 서울특별시 은평구 통일로 89길 5-10 엔티티웍스 B/D (갈현동)',
        tel: '1566-8085',
        fax: '02-352-8672',
        email: 'syscall@nttworks.com',
        privacyPolicyURL: 'https://syscallsafe.com/privacy'
      }
    }
    // 전역 클릭 이벤트 등록
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    // 전역 클릭 이벤트 제거
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    // 파비콘 변경
    changeFavicon(iconUrl) {
            
        // 기존 favicon 요소 찾기
        let link = document.querySelector("link[rel='icon']");
        
        if (link) {
            // 기존 favicon을 삭제 후 다시 추가 (캐싱 문제 방지)
            document.head.removeChild(link);
        } else {
            // 새 favicon 요소 생성
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }

        // 새로운 favicon 적용
        link.href = iconUrl + '?v=' + new Date().getTime(); // 캐싱 방지 위해 타임스탬프 추가
        document.head.appendChild(link);
    },
    
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    handleOutsideClick(event) {
      // 드롭다운 외부를 클릭했는지 확인
      if (this.$refs.profile && !this.$refs.profile.contains(event.target)) {
        this.dropdownVisible = false;
      }
    },
  },
};
</script>
